import ic_insta_color from './Recursos/ic_inst_color.svg'
import ic_face_color from './Recursos/ic_face_color.svg'
import inst from './Recursos/ic_insta.svg'
import face from './Recursos/ic_face.svg'
import tiktok from './Recursos/ic_tiktok.svg'

export const SECCIONES = ['Inicio', 'Blog', 'Instructores',]

export const NEGRITA = 'Roboto'

export const COLORTEXTO = '#323232'

export const WASS = '3172880347'

export const INDICADORES = [
    {
        nombre: 'Profesionales Disponibles',
        //  img: empanada,
        numero: 32
    },
    {
        nombre: 'Asistentes a Espacios',
        //  img: feliz,
        numero: 3500
    },
    {
        nombre: 'Espacios Inpartidos',
        //    img: casa,
        numero: 3
    },
    {
        nombre: 'Ganas de Ayudar',
        //    img: casa,
        numero: 1000
    },
]


export const REDES = [
    {
        nombre: 'tiktok',
        imgColor: tiktok,
        img: tiktok,
        url: 'https://www.tiktok.com/@somoscreenciacentral?_r=1&_t=ZS-95cMNqasO3g'
    },
    {
        nombre: 'facebook',
        imgColor: ic_face_color,
        img: face,
        url: 'https://www.facebook.com/profile.php?id=61579322414495'
    },
    {
        nombre: 'instagram',
        imgColor: ic_insta_color,
        img: inst,
        url: 'https://www.instagram.com/somoscreenciacentral?igsh=MTJ4aDZvMHRkcnFhdA=='
    },
]

export const CONTACTOS = [
    {
        nombre: 'Celular',
        descripcion: '+57 317 288 0347'
    }, {
        nombre: 'Correo',
        descripcion: 'info@quesuditas.com'
    }

]


export const LINKMENU = 'https://quesuditas.com/menus/menu.pdf'

export const TESTIMONIOS =

    [
        {
            "nombre": "Facundo Rossi",
            "testimonio": "Asistir a la conferencia virtual de Creencia Central con el Dr. Battafarano fue un antes y un después. En medio de tanta incertidumbre laboral, sus palabras sobre la 'psicopatología de lo accesorio' me ayudaron a soltar lo que no importaba y reencontrarme con mi verdadero propósito. Realmente es una brújula necesaria para estos tiempos."
        },
        {
            "nombre": "Mariana Pertusi",
            "testimonio": "Me impactó la claridad para explicar la Logoterapia. Sentía que el día a día me pasaba por arriba, pero el testimonio y la calidez del profesional me dieron herramientas prácticas para elegir mi actitud frente a las crisis. Gracias a Creencia Central por acercar estos contenidos de forma tan accesible."
        },
        {
            "nombre": "Bautista Maidana",
            "testimonio": "Excelente charla. Lo que más me sirvió fue entender que la plenitud no se trata de tener todo bajo control, sino de encontrar un 'para qué' en lo que ya estoy haciendo. Como argentino, valoro mucho tener un referente que hable nuestro idioma y entienda nuestra realidad actual con tanta profundidad humana."
        },
        {
            "nombre": "Lucía Fernández",
            "testimonio": "La conferencia me ayudó a bajar la ansiedad que me generaba el futuro. El Dr. Mauricio explica conceptos complejos de una manera muy cercana. Me fui con la sensación de que, aunque el entorno sea difícil, mi libertad interior sigue intacta. Un espacio de salud emocional que recomiendo a todos."
        }
    ]

export const SERVICIOS = [
    'Proximamente'
]